import React from "react";
import { Form } from "react-bootstrap";

import EvaluationResultLabelTips from "presentation/pages/evaluation-result-labels/elements/evaluation-result-label-tips";
import RemoveAction from "presentation/components/remove-action";

import AddButton from "presentation/components/buttons/add";

import {
    changeEvaluationResultLabelTermsList,
    handleChangeEvaluationResultLabelTerms,
    evaluationResultLabelTermsFormValue,
    mountItems
} from 'presentation/pages/evaluation-result-labels/functions/evaluation-result-label-terms';

class EvaluationResultLabelTerms extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};

    }

    addOption = () => {
        let { component } = this.props;
        let { totalItems } = component.state;
        component.setState({ ...component.state, totalItems: totalItems + 1 }, () => mountItems(component));
    }

    removeAction = (key) => {
        let { component } = this.props;

        let { totalItems } = component.state;

        let evaluationResultLabelTerms = changeEvaluationResultLabelTermsList(component, { key: key }, true);

        //reorganiza as keys
        let index = 0;
        evaluationResultLabelTerms.map((element, i) => {
            if (!element.isDeleteRequested) {
                element.key = index + 1;
                index++;
            }
            return element;
        });

        component.setState({ ...component.state, totalItems: totalItems - 1, evaluationResultLabelTerms: evaluationResultLabelTerms }, () => mountItems(component));
    }

    render() {
        let { component } = this.props;
        const { evaluationResultLabelTerms, loading, totalItems, form } = component.state;

        const { addOption, removeAction } = this;

        const validEvaluationResultLabelTerms = evaluationResultLabelTerms.filter(x => !x.isDeleteRequested);

        return (
            <div>
                <h5 className="mt-4">Termos do rótulo</h5>
                <table className="table table-borderless">
                    <thead>
                        <tr>
                            <th width="20%">Exibir o rótulo</th>
                            <th className="text-end" width="25%">{"Quando o valor >= que"}</th>
                            <th className="text-end" width="25%">{"E <= que"}</th>
                            <th width="30%"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {validEvaluationResultLabelTerms.map((element, index) => {
                            let key = element.key;

                            let nameValue = evaluationResultLabelTermsFormValue(key, 'name', component);
                            let numericRangeStartValue = evaluationResultLabelTermsFormValue(key, 'numericRangeStart', component);
                            let numericRangeEndValue = evaluationResultLabelTermsFormValue(key, 'numericRangeEnd', component);
                            const deleteIsDisabled = totalItems < 2;
                            return (
                                <tr key={`evaluation-result-label-term-${key}`}>
                                    <td>
                                        <Form.Control
                                            type="text"
                                            id={`name-${key}`}
                                            name={`name-${key}`}
                                            data-field-name="name"
                                            defaultValue={nameValue || ""}
                                            onChange={(event) => handleChangeEvaluationResultLabelTerms(key, event, component)}
                                        />
                                    </td>
                                    <td>
                                        <Form.Control
                                            type="numericRangeStart"
                                            id={`numericRangeStart-${key}`}
                                            name={`numericRangeStart-${key}`}
                                            data-field-name="numericRangeStart"
                                            defaultValue={numericRangeStartValue || undefined}
                                            onChange={(event) => handleChangeEvaluationResultLabelTerms(key, event, component)}
                                        />
                                    </td>
                                    <td>
                                        <Form.Control
                                            type="numericRangeEnd"
                                            id={`numericRangeEnd-${key}`}
                                            name={`numericRangeEnd-${key}`}
                                            data-field-name="numericRangeEnd"
                                            defaultValue={numericRangeEndValue || undefined}
                                            onChange={(event) => handleChangeEvaluationResultLabelTerms(key, event, component)}
                                        />
                                    </td>
                                    <td>
                                        <RemoveAction
                                            className="float-end"
                                            component={this}
                                            optionKey={key}
                                            loading={loading}
                                            deleteIsDisabled={deleteIsDisabled}
                                            removeAction={removeAction} />
                                    </td>
                                </tr>
                            );
                        })}
                        <tr>
                            <td colSpan={3}>
                                <div className="text-end">
                                    <AddButton
                                        containerProps={{
                                            onClick: addOption,
                                            variant: 'success',
                                            className: 'mt-1 mb-1'

                                        }}
                                        title='Adicionar termo'
                                    />
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <EvaluationResultLabelTips component={this} form={form} />
            </div>
        );
    };
}

export default EvaluationResultLabelTerms;